(function(){
  var root=document.getElementById('zorro-pp');
  if(!root||root.dataset.init)return; root.dataset.init='1';
  function eur(n){return '€'+(Number(n)).toFixed(2).replace('.',',');}
  function money(c){return eur(c/100);}
  function $(id){return document.getElementById(id);}
  var routeRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  var viewingSuffix=root.dataset.viewingSuffix||'viewing now',
      cartShipping=root.dataset.cartShipping||'€6,20 straight-to-door in Finland for 1–2 pairs. Larger shinpad orders use a higher non-door rate.',
      emptyCart=root.dataset.emptyCart||'Your cart is empty',
      addedLabel=root.dataset.added||'Added to cart',
      saveLabel=root.dataset.saveLabel||'Save',
      giveawaySuccess=root.dataset.giveawaySuccess||'You’re in — check your inbox',
      decreaseLabel=root.dataset.decreaseLabel||'Decrease',
      increaseLabel=root.dataset.increaseLabel||'Increase',
      removeLabel=root.dataset.removeLabel||'Remove';
  function escapeHtml(value){return String(value).replace(/[&<>"']/g,function(ch){return({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'})[ch];});}

  /* marquee + club bands */
  var mqItems=escapeHtml(root.dataset.announcementOne||'OUTWORK THE REST')+'&nbsp;&nbsp;<b>✦</b>&nbsp;&nbsp;'+escapeHtml(root.dataset.announcementTwo||'BUILT FOR FOOTBALL')+'&nbsp;&nbsp;<b>✦</b>&nbsp;&nbsp;'+escapeHtml(root.dataset.announcementThree||'TRUSTED BY PRO ATHLETES')+'&nbsp;&nbsp;<b>✦</b>&nbsp;&nbsp;'+escapeHtml(root.dataset.announcementFour||'14-DAY RETURNS')+'&nbsp;&nbsp;<b>✦</b>&nbsp;&nbsp;';
  if($('zpp-mq')) $('zpp-mq').innerHTML='<span>'+mqItems+'</span><span>'+mqItems+'</span><span>'+mqItems+'</span><span>'+mqItems+'</span>';
  var clubs='VEIKKAUSLIIGA&nbsp;&nbsp;<b>+</b>&nbsp;&nbsp;YKKÖNEN&nbsp;&nbsp;<b>+</b>&nbsp;&nbsp;KAKKONEN&nbsp;&nbsp;<b>+</b>&nbsp;&nbsp;ACADEMY&nbsp;&nbsp;<b>+</b>&nbsp;&nbsp;FUTSAL&nbsp;&nbsp;<b>+</b>&nbsp;&nbsp;';
  if($('zpp-club')) $('zpp-club').innerHTML='<span>'+clubs+'</span><span>'+clubs+'</span><span>'+clubs+'</span>';

  /* ===== price state ===== */
  var nowEl=$('zpp-now'), wasEl=$('zpp-was'), saveEl=$('zpp-save'),
      ctaPrice=$('zpp-ctaprice'), sbPrice=$('zpp-sbprice');
  var state={vid:root.dataset.vid||'', price:parseFloat(root.dataset.price||'0'), was:parseFloat(root.dataset.was||'0'), qty:1};
  function setPrice(price,was){
    state.price=price; state.was=was||0;
    if(nowEl) nowEl.textContent=eur(price);
    if(wasEl){ if(was&&was>price){wasEl.style.display='';wasEl.textContent=eur(was);} else wasEl.style.display='none'; }
    if(saveEl){
      if(was&&was>price){var s=was-price;var pct=Math.round(s/was*100);saveEl.style.display='';saveEl.textContent=saveLabel+' '+eur(s)+' · −'+pct+'%';}
      else saveEl.style.display='none';
    }
    var disp=eur(price);
    if(ctaPrice) ctaPrice.textContent=disp;
    if(sbPrice) sbPrice.textContent=disp;
  }

  /* ===== variants + bundle tiers ===== */
  var tiers=$('zpp-tiers'), variantPicker=$('zpp-variant-picker'), variants=[], variantGroups=[], syncSelectedVariant;
  if(variantPicker&&$('zpp-variant-data')){
    try{variants=JSON.parse($('zpp-variant-data').textContent||'[]');}catch(e){variants=[];}
    variantGroups=Array.from(variantPicker.querySelectorAll('.variant-group[data-option-index]'));
  }
  function selectedOptions(){
    return variantGroups.map(function(group){var selected=group.querySelector('.variant-choice.on');return selected?selected.dataset.optionValue:'';});
  }
  function matchesOptions(variant,options){
    return options.every(function(value,index){return variant.options&&variant.options[index]===value;});
  }
  function selectedTierVariantId(tier){
    if(!tier)return '';
    var source=$(tier.dataset.variantData||''), tierVariants=[];
    if(source){try{tierVariants=JSON.parse(source.textContent||'[]');}catch(e){tierVariants=[];}}
    if(!tierVariants.length)return String(tier.dataset.vid||'');
    var selected=selectedOptions();
    var match=tierVariants.find(function(variant){
      return variant.available&&(variant.options||[]).every(function(value){return value==='Default Title'||selected.indexOf(value)!==-1;});
    })||tierVariants.find(function(variant){return variant.available;});
    return match?String(match.id):'';
  }
  if(tiers){
    tiers.addEventListener('click',function(e){
      var t=e.target.closest('.tier'); if(!t)return;
      this.querySelectorAll('.tier').forEach(function(x){x.classList.remove('on');});
      t.classList.add('on');state.qty=1;
      if(syncSelectedVariant){syncSelectedVariant();return;}
      state.vid=selectedTierVariantId(t);
      t.dataset.selectedVid=state.vid;
      setPrice(parseFloat(t.dataset.total),parseFloat(t.dataset.was||'0'));
    });
  }

  if(variantPicker&&variants.length){
    function updateOptionAvailability(){
      var current=selectedOptions();
      variantGroups.forEach(function(group,index){
        group.querySelectorAll('.variant-choice').forEach(function(choice){
          var candidate=current.slice();candidate[index]=choice.dataset.optionValue;
          var available=variants.some(function(variant){return variant.available&&matchesOptions(variant,candidate);});
          choice.disabled=!available;
          choice.classList.toggle('is-unavailable',!available);
          choice.setAttribute('aria-disabled',available?'false':'true');
        });
      });
    }
    syncSelectedVariant=function(){
      var selected=selectedOptions();
      var variant=variants.find(function(item){return matchesOptions(item,selected);});
      var activeTier=tiers&&tiers.querySelector('.tier.on');
      var isPack=Boolean(activeTier&&activeTier.dataset.tierKind==='pack');
      var targetId=isPack?selectedTierVariantId(activeTier):(variant?String(variant.id):'');
      var available=Boolean(variant&&variant.available&&targetId);
      [$('zpp-add'),$('zpp-sbadd'),$('zpp-buynow')].forEach(function(button){if(button)button.disabled=!available;});
      if(!variant)return;
      state.vid=targetId;state.qty=1;
      if(activeTier)activeTier.dataset.selectedVid=targetId;
      if(isPack){setPrice(parseFloat(activeTier.dataset.total),parseFloat(activeTier.dataset.was||'0'));}
      else{
        setPrice(Number(variant.price||0)/100,Number(variant.compare_at_price||0)/100);
        try{var url=new URL(window.location.href);url.searchParams.set('variant',variant.id);window.history.replaceState({},'',url.pathname+url.search+url.hash);}catch(e){}
      }
    };
    variantPicker.addEventListener('click',function(e){
      var choice=e.target.closest('.variant-choice');if(!choice||choice.disabled)return;
      var group=choice.closest('.variant-group');
      group.querySelectorAll('.variant-choice').forEach(function(item){var active=item===choice;item.classList.toggle('on',active);item.setAttribute('aria-pressed',active?'true':'false');});
      var currentLabel=group.querySelector('[data-option-current]');if(currentLabel){var displayChoice=choice.querySelector('.variant-choice-name');currentLabel.textContent=displayChoice?displayChoice.textContent.trim():choice.dataset.optionValue;}
      updateOptionAvailability();syncSelectedVariant();showChoiceImage(choice);
    });
    updateOptionAvailability();syncSelectedVariant();
  }

  /* ===== qty stepper (non-tier products) ===== */
  var qtyInput=$('zpp-qty');
  if(qtyInput){
    var dec=$('zpp-qdec'), inc=$('zpp-qinc');
    function setQ(v){state.qty=Math.max(1,v);qtyInput.value=state.qty;}
    if(dec)dec.onclick=function(){setQ(state.qty-1);};
    if(inc)inc.onclick=function(){setQ(state.qty+1);};
    qtyInput.addEventListener('change',function(){setQ(parseInt(qtyInput.value,10)||1);});
  }

  /* ===== gallery ===== */
  var mainImg=$('zpp-main'), thumbs=$('zpp-thumbs'), mainFrame=mainImg&&mainImg.closest('.g-main'), gallerySwitch=0, galleryResize;
  var zStickyPx=144,zStickyApplied=false;
  function zSyncStickyTop(){
    var bar=document.querySelector('.zorro-sale-bar');
    var headers=Array.prototype.slice.call(document.querySelectorAll('.zshared-header'));
    var header=headers.filter(function(h){return h.getBoundingClientRect().height>0;}).pop();
    var px=Math.round((bar?bar.getBoundingClientRect().height:0)+(header?header.getBoundingClientRect().height:0)+12);
    if(px<40)px=88;
    if(px===zStickyPx&&zStickyApplied)return;
    zStickyApplied=true;zStickyPx=px;
    document.documentElement.style.setProperty('--zorro-sticky-top',px+'px');
  }
  function fitMainFrame(w,h,instant){
    if(!mainFrame||!w||!h)return;
    var available=mainFrame.parentElement.clientWidth;
    if(!available)return;
    /* Desktop: square frame that fills the gallery column. Images are
       object-fit:cover, so portrait shots fill it instead of leaving big
       black side gaps. Mobile keeps each image's own ratio. */
    var desktop=window.innerWidth>900, ratio=desktop?1:w/h;
    var maxHeight=desktop?Math.max(360,Math.min(available,window.innerHeight-zStickyPx-24)):Math.max(320,window.innerHeight*.78);
    var targetWidth=available, targetHeight=targetWidth/ratio;
    if(targetHeight>maxHeight){targetHeight=maxHeight;targetWidth=targetHeight*ratio;}
    if(instant)mainFrame.classList.add('no-motion');
    mainFrame.style.width=Math.round(targetWidth)+'px';
    mainFrame.style.height=Math.round(targetHeight)+'px';
    mainFrame.style.setProperty('--zpp-image-ratio',desktop?'1 / 1':w+' / '+h);
    mainFrame.dataset.width=w;mainFrame.dataset.height=h;
    /* desktop: keep the vertical thumb rail exactly as tall as the image so it
       scrolls internally instead of stretching the gallery past the photo */
    if(thumbs)thumbs.style.maxHeight=window.innerWidth>900?Math.round(targetHeight)+'px':'';
    if(instant)requestAnimationFrame(function(){mainFrame.classList.remove('no-motion');});
  }
  function revealGalleryImage(t,full,loader,token){
    if(token!==gallerySwitch||!mainFrame||!mainImg)return;
    mainFrame.querySelectorAll('.zpp-image-ghost').forEach(function(image){image.remove();});
    var ghost=mainImg.cloneNode(false);
    ghost.removeAttribute('id');ghost.removeAttribute('fetchpriority');ghost.alt='';ghost.setAttribute('aria-hidden','true');ghost.className='zpp-image-ghost';
    mainFrame.appendChild(ghost);
    mainImg.classList.add('is-entering');
    mainImg.src=full;mainImg.alt=t.getAttribute('data-alt')||mainImg.alt;
    fitMainFrame(parseFloat(t.dataset.width)||loader.naturalWidth,parseFloat(t.dataset.height)||loader.naturalHeight,false);
    mainFrame.removeAttribute('aria-busy');
    requestAnimationFrame(function(){requestAnimationFrame(function(){mainImg.classList.remove('is-entering');ghost.classList.add('is-leaving');});});
    setTimeout(function(){if(ghost.parentNode)ghost.remove();},520);
  }
  zSyncStickyTop();
  (function(){
    var relayout=function(){zSyncStickyTop();if(mainFrame)fitMainFrame(parseFloat(mainFrame.dataset.width),parseFloat(mainFrame.dataset.height),true);};
    window.addEventListener('resize',relayout);
    if(window.ResizeObserver){
      var ro=new ResizeObserver(relayout);
      ['.zorro-sale-bar','.zshared-header'].forEach(function(sel){
        document.querySelectorAll(sel).forEach(function(el){ro.observe(el);});
      });
    }
  }());
  if(mainFrame&&mainImg){
    fitMainFrame(parseFloat(mainFrame.dataset.width)||mainImg.naturalWidth,parseFloat(mainFrame.dataset.height)||mainImg.naturalHeight,true);
    window.addEventListener('resize',function(){clearTimeout(galleryResize);galleryResize=setTimeout(function(){fitMainFrame(parseFloat(mainFrame.dataset.width),parseFloat(mainFrame.dataset.height),true);},120);});
  }
  if(thumbs&&mainImg){
    var selectedThumb=thumbs.querySelector('.t.on')||thumbs.querySelector('.t');
    function clearGalleryPreview(){thumbs.querySelectorAll('.t.preview').forEach(function(x){x.classList.remove('preview');});}
    function showGalleryImage(t,persist,scrollThumb){
      if(!t)return;
      var full=t.getAttribute('data-full');
      if(!full)return;
      clearGalleryPreview();
      if(persist){
        selectedThumb=t;
        thumbs.querySelectorAll('.t').forEach(function(x){x.classList.remove('on');x.setAttribute('aria-pressed','false');});
        t.classList.add('on');t.setAttribute('aria-pressed','true');
      }else if(t!==selectedThumb){t.classList.add('preview');}
      if(scrollThumb)t.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
      var token=++gallerySwitch;
      if(mainImg.src===full){if(mainFrame)mainFrame.removeAttribute('aria-busy');return;}
      var loader=new Image();
      if(mainFrame)mainFrame.setAttribute('aria-busy','true');
      loader.decoding='async';
      loader.onload=function(){
        var ready=function(){revealGalleryImage(t,full,loader,token);};
        if(loader.decode)loader.decode().catch(function(){}).then(ready);else ready();
      };
      loader.onerror=function(){if(token===gallerySwitch&&mainFrame)mainFrame.removeAttribute('aria-busy');};
      loader.src=full;
    }
    thumbs.addEventListener('click',function(e){var t=e.target.closest('.t');if(t)showGalleryImage(t,true,true);});
    thumbs.querySelectorAll('.t').forEach(function(t){
      if(window.matchMedia&&window.matchMedia('(hover: hover)').matches)t.addEventListener('mouseenter',function(){showGalleryImage(t,false,false);});
      t.addEventListener('focus',function(){showGalleryImage(t,false,false);});
    });
    thumbs.addEventListener('mouseleave',function(){clearGalleryPreview();showGalleryImage(selectedThumb,false,false);});
    thumbs.addEventListener('focusout',function(){setTimeout(function(){if(!thumbs.contains(document.activeElement)){clearGalleryPreview();showGalleryImage(selectedThumb,false,false);}},0);});

    /* ===== gallery navigation: swipe (touch + mouse drag), arrow buttons, arrow keys ===== */
    function galleryTiles(){return Array.prototype.slice.call(thumbs.querySelectorAll('.t'));}
    function centerThumb(t){
      if(!t)return;
      var tb=t.getBoundingClientRect(),cb=thumbs.getBoundingClientRect();
      /* vertical rail (desktop) vs horizontal strip (mobile) */
      if(thumbs.scrollHeight>thumbs.clientHeight+2){
        if(tb.top<cb.top||tb.bottom>cb.bottom){
          var top=thumbs.scrollTop+(tb.top-cb.top)-(cb.height-tb.height)/2;
          if(thumbs.scrollTo)thumbs.scrollTo({top:top,behavior:'smooth'});else thumbs.scrollTop=top;
        }
        return;
      }
      if(tb.left<cb.left||tb.right>cb.right){
        var target=thumbs.scrollLeft+(tb.left-cb.left)-(cb.width-tb.width)/2;
        if(thumbs.scrollTo)thumbs.scrollTo({left:target,behavior:'smooth'});else thumbs.scrollLeft=target;
      }
    }
    function galleryStep(dir){
      var tiles=galleryTiles();
      if(tiles.length<2)return;
      var cur=tiles.indexOf(selectedThumb);
      if(cur<0)cur=0;
      var next=tiles[(cur+dir+tiles.length)%tiles.length];
      showGalleryImage(next,true,false);
      centerThumb(next);
    }
    var swipeEndedAt=0;
    if(mainFrame){
      mainFrame.addEventListener('click',function(e){
        var nav=e.target.closest&&e.target.closest('[data-zpp-nav]');
        if(!nav)return;
        e.preventDefault();
        if(Date.now()-swipeEndedAt<260)return;
        galleryStep(parseInt(nav.getAttribute('data-zpp-nav'),10)||1);
      });
      var swipe=null;
      mainFrame.addEventListener('pointerdown',function(e){
        if(e.pointerType==='mouse'&&e.button!==0)return;
        if(e.target.closest&&e.target.closest('[data-zpp-nav]'))return;
        if(galleryTiles().length<2)return;
        swipe={x:e.clientX,y:e.clientY,id:e.pointerId,dx:0,moved:false};
      });
      mainFrame.addEventListener('pointermove',function(e){
        if(!swipe||e.pointerId!==swipe.id)return;
        var dx=e.clientX-swipe.x,dy=e.clientY-swipe.y;
        if(!swipe.moved){
          if(Math.abs(dx)<7)return;
          /* vertical intent = let the page scroll, drop the gesture */
          if(Math.abs(dx)<=Math.abs(dy)){swipe=null;return;}
          swipe.moved=true;
          mainFrame.classList.add('is-swiping');
          if(mainFrame.setPointerCapture){try{mainFrame.setPointerCapture(e.pointerId);}catch(err){}}
        }
        swipe.dx=dx;
        mainFrame.style.transform='translateX('+(dx*0.32).toFixed(1)+'px)';
      });
      function endSwipe(){
        if(!swipe)return;
        var moved=swipe.moved,dx=swipe.dx;
        swipe=null;
        mainFrame.classList.remove('is-swiping');
        mainFrame.style.transform='';
        if(!moved)return;
        swipeEndedAt=Date.now();
        if(Math.abs(dx)>42)galleryStep(dx<0?1:-1);
      }
      mainFrame.addEventListener('pointerup',endSwipe);
      mainFrame.addEventListener('pointercancel',endSwipe);
      mainFrame.addEventListener('dragstart',function(e){e.preventDefault();});
    }
    document.addEventListener('keydown',function(e){
      if(e.key!=='ArrowLeft'&&e.key!=='ArrowRight')return;
      if(e.metaKey||e.ctrlKey||e.altKey||e.shiftKey)return;
      var el=document.activeElement;
      if(el&&el.closest&&el.closest('input,textarea,select,[contenteditable="true"]'))return;
      if(galleryTiles().length<2)return;
      var gal=thumbs.closest('.gallery')||mainFrame;
      if(!gal)return;
      /* only hijack the arrows while the gallery is actually on screen */
      var box=gal.getBoundingClientRect(),vh=window.innerHeight||0;
      if(box.bottom<80||box.top>vh-80)return;
      e.preventDefault();
      galleryStep(e.key==='ArrowRight'?1:-1);
    });
  }
  function showChoiceImage(choice){
    if(!choice||!mainImg)return;
    var full=choice.dataset.imageFull;if(!full)return;
    var stickyImage=document.querySelector('#zorro-pp .sb-thumb img');if(stickyImage)stickyImage.src=full;
    var matchingThumb=null;
    if(thumbs)matchingThumb=Array.from(thumbs.querySelectorAll('.t')).find(function(thumb){return thumb.getAttribute('data-full')===full;});
    if(matchingThumb){showGalleryImage(matchingThumb,true,true);return;}
    var token=++gallerySwitch,loader=new Image();
    if(mainFrame)mainFrame.setAttribute('aria-busy','true');
    loader.decoding='async';
    loader.onload=function(){
      if(token!==gallerySwitch)return;
      revealGalleryImage(choice,full,loader,token);
    };
    loader.onerror=function(){if(token===gallerySwitch&&mainFrame)mainFrame.removeAttribute('aria-busy');};
    loader.src=full;
  }

  /* ===== accordions ===== */
  document.querySelectorAll('#zorro-pp .acc .q').forEach(function(q){q.onclick=function(){q.parentElement.classList.toggle('open');};});
  document.querySelectorAll('#zorro-pp .faq-item .q').forEach(function(q){q.onclick=function(){q.parentElement.classList.toggle('open');};});
  var sg=$('zpp-sizeguide');
  var sgDialog=$('zpp-size-guide-dialog');
  var sgClose=$('zpp-size-guide-close');
  function closeSizeGuide(){if(sgDialog&&sgDialog.open)sgDialog.close();}
  if(sg)sg.onclick=function(e){
    e.preventDefault();
    if(sgDialog&&typeof sgDialog.showModal==='function'){
      sgDialog.showModal();
      return;
    }
    var it=document.querySelector('#zorro-pp [data-size-guide-panel]');
    if(!it)return;
    it.classList.add('open');
    it.scrollIntoView({behavior:'smooth',block:'nearest'});
  };
  if(sgClose)sgClose.onclick=closeSizeGuide;
  if(sgDialog)sgDialog.addEventListener('click',function(e){if(e.target===sgDialog)closeSizeGuide();});

  /* ===== countdown + watchers ===== */
  var clock=$('zpp-clock');
  function p2(n){return(n<10?'0':'')+n;}
  function tickClock(){if(!clock)return;var d=new Date();var sec=d.getHours()*3600+d.getMinutes()*60+d.getSeconds();var rem=10800-(sec%10800);var h=Math.floor(rem/3600),m=Math.floor((rem%3600)/60),s=rem%60;clock.textContent=p2(h)+':'+p2(m)+':'+p2(s);}
  if(clock){tickClock();setInterval(tickClock,1000);}
  var watch=$('zpp-watch');
  if(watch)setInterval(function(){watch.textContent=(21+Math.floor(Math.random()*19))+' '+viewingSuffix;},5000);

  /* ===== reviews carousel ===== */
  var rt=$('zpp-rtrack');
  if(rt){ if($('zpp-rprev'))$('zpp-rprev').onclick=function(){rt.scrollBy({left:-348,behavior:'smooth'});}; if($('zpp-rnext'))$('zpp-rnext').onclick=function(){rt.scrollBy({left:348,behavior:'smooth'});}; }

  /* ===== cart drawer ===== */
  var drawer=$('zpp-drawer'), scrim=$('zpp-scrim');
  function openCart(){if(!drawer||!scrim)return;drawer.classList.add('open');scrim.classList.add('open');drawer.setAttribute('aria-hidden','false');document.body.classList.add('zorro-cart-open');}
  function closeCart(){if(!drawer||!scrim)return;drawer.classList.remove('open');scrim.classList.remove('open');drawer.setAttribute('aria-hidden','true');document.body.classList.remove('zorro-cart-open');}
  if($('zpp-cartbtn'))$('zpp-cartbtn').addEventListener('click',function(e){e.preventDefault();refresh(true);});
  if($('zpp-close'))$('zpp-close').addEventListener('click',function(e){e.preventDefault();e.stopPropagation();closeCart();});
  if(scrim)scrim.addEventListener('click',function(e){e.preventDefault();closeCart();});
  document.addEventListener('click',function(e){if(!drawer||!drawer.classList.contains('open'))return;if(drawer.contains(e.target)||e.target.closest('#zpp-cartbtn'))return;closeCart();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeCart();});

  var giftLabel=(root&&root.getAttribute('data-gift-free'))||'Free with your bundle';
  function renderCart(cart){
    zgiftPrune(cart);
    var body=$('zpp-dbody'); if(!body)return;
    if($('zpp-dcount'))$('zpp-dcount').textContent=cart.item_count;
    if($('zpp-cartdot')){$('zpp-cartdot').textContent=cart.item_count;$('zpp-cartdot').style.display=cart.item_count>0?'':'none';}
    if($('zpp-dsubtotal'))$('zpp-dsubtotal').textContent=money(cart.total_price);
    if(window.ZorroCampaign)window.ZorroCampaign.updateCart(cart);
    if(!cart.items.length){body.innerHTML='<div style="text-align:center;padding:54px 20px;color:var(--muted);font-family:var(--mono);font-size:12px;letter-spacing:.06em;text-transform:uppercase">'+escapeHtml(emptyCart)+'</div>';return;}
    var html='';
    cart.items.forEach(function(it){
      var img=it.image?it.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x$1$2'):'';
      var gift=!!(it.properties&&it.properties._zorro_gift);
      html+='<div class="zd-row" data-key="'+it.key+'">'
        +(img?'<img src="'+img+'" alt="">':'<div style="width:64px;height:64px;border-radius:10px;background:var(--bg2);flex-shrink:0"></div>')
        +'<div style="flex:1;min-width:0">'
        +'<div style="font-family:var(--disp);font-style:italic;font-weight:800;font-size:15px;text-transform:uppercase;line-height:1.05">'+it.product_title+'</div>'
        +(it.variant_title&&it.variant_title!=='Default Title'?'<div style="font-family:var(--mono);font-size:10px;color:var(--muted);text-transform:uppercase;margin-top:3px">'+it.variant_title+'</div>':'')
        +(gift
          ?'<div style="display:flex;align-items:center;justify-content:space-between;margin-top:6px"><span style="font-family:var(--mono);font-size:10px;letter-spacing:.06em;text-transform:uppercase;color:var(--accent2)">'+escapeHtml(giftLabel)+'</span><span style="font-weight:700;font-size:14px">'+money(it.final_line_price)+'</span></div></div>'
          :'<div style="display:flex;align-items:center;justify-content:space-between;margin-top:6px">'
        +'<div class="zd-q"><button data-act="dec" aria-label="'+escapeHtml(decreaseLabel)+'">−</button><span>'+it.quantity+'</span><button data-act="inc" aria-label="'+escapeHtml(increaseLabel)+'">+</button></div>'
        +'<span style="font-weight:700;font-size:14px">'+money(it.final_line_price)+'</span>'
        +'</div></div>'
        +'<button class="zd-x" data-act="remove" aria-label="'+escapeHtml(removeLabel)+'"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6 6 18"/></svg></button>')
        +'</div>';
    });
    body.innerHTML=html;
  }
  document.addEventListener('zorro:mysterybox:cart',function(e){if(e.detail)renderCart(e.detail);});
  function refresh(open){fetch(routeRoot+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(c){renderCart(c);if(open)openCart();});}
  function change(key,q){fetch(routeRoot+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:q})}).then(function(r){return r.json();}).then(renderCart);}
  if($('zpp-dbody'))$('zpp-dbody').addEventListener('click',function(e){
    var b=e.target.closest('button[data-act]'); if(!b)return;
    var row=b.closest('.zd-row'), key=row.getAttribute('data-key'), cur=parseInt(row.querySelector('.zd-q span').textContent,10)||0, a=b.getAttribute('data-act');
    if(a==='inc')change(key,cur+1); else if(a==='dec')change(key,Math.max(0,cur-1)); else change(key,0);
  });

  /* ===== toast ===== */
  var toast=$('zpp-toast'), tmsg=$('zpp-toastmsg'), tHide;
  function showToast(msg){ if(!toast)return; tmsg.textContent=msg; toast.classList.add('show'); clearTimeout(tHide); tHide=setTimeout(function(){toast.classList.remove('show');},2600); }

  function addToCart(items, msg){
    fetch(routeRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){return r.json();}).then(function(){showToast(msg||addedLabel);refresh(true);})
      .catch(function(){});
  }

  /* main add-to-cart */
  function mainAdd(){
    if(!state.vid)return;
    var items=[{id:Number(state.vid),quantity:state.qty}],gift=zgiftLine();
    if(gift)items.push(gift);
    if(gift)zgiftAdd(items,addedLabel+' + free gripsocks · '+eur(state.price*state.qty));
    else addToCart(items,addedLabel+' · '+eur(state.price*state.qty));
  }
  if($('zpp-add'))$('zpp-add').onclick=mainAdd;
  if($('zpp-sbadd'))$('zpp-sbadd').onclick=mainAdd;
  if($('zpp-buynow'))$('zpp-buynow').onclick=function(){
    if(!state.vid)return;
    var items=[{id:Number(state.vid),quantity:state.qty}],gift=zgiftLine();
    if(gift)items.push(gift);
    var go=function(){window.location=routeRoot+'checkout';};
    fetch(routeRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){
        if(r.ok||!gift)return go();
        /* gift sold out between picking and adding: never block the bundle */
        return fetch(routeRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[items[0]]})}).then(go);
      }).catch(go);
  };

  /* related add buttons */
  document.querySelectorAll('#zorro-pp .zpp-padd').forEach(function(b){
    b.onclick=function(){ if(b.dataset.vid) addToCart([{id:Number(b.dataset.vid),quantity:1}],addedLabel); };
  });

  /* giveaway */
  var gform=document.querySelector('#zorro-pp .give form');
  if(gform)gform.addEventListener('submit',function(e){e.preventDefault();showToast(giveawaySuccess);});

  /* sticky bar */
  var bar=$('zpp-sticky'), addBtn=$('zpp-add');
  if(bar&&addBtn){var sync=function(){var b=addBtn.getBoundingClientRect();bar.classList.toggle('show',b.bottom<8);};window.addEventListener('scroll',sync,{passive:true});window.addEventListener('resize',sync);sync();}

  /* ===== first-hour free gripsocks (Ultimate Bundle) =====
     Making the pair actually free is a SCHEDULED Shopify "Buy X get Y"
     automatic discount (13.9.2026 18:00-19:00 Europe/Helsinki). This code only
     lets the customer pick the pair, adds it next to the bundle, and pulls the
     whole offer the moment the socks run out. Stock is re-checked live against
     Shopify before every add, because the page itself is cached. */
  var zgiftBox=document.querySelector('#zorro-pp [data-zgift-pick]');
  var zgiftHandles=['zorrogrip-2-0-gripsocks','zorrogrip-black'];
  var zgift={live:{},variant:'',color:'',skew:0,dead:false,pruning:false};
  var zgiftTimer=null;

  function zgiftColourBtns(){return zgiftBox?Array.prototype.slice.call(zgiftBox.querySelectorAll('.zgift-row:not([data-zgift-sizes]) .zgift-opt')):[];}
  function zgiftSizeBtns(){return zgiftBox?Array.prototype.slice.call(zgiftBox.querySelectorAll('[data-zgift-sizes] .zgift-opt')):[];}
  function zgiftIds(){return zgiftSizeBtns().map(function(b){return b.getAttribute('data-zgift-variant');});}
  function zgiftSizeBtnsFor(c){return zgiftSizeBtns().filter(function(b){return b.getAttribute('data-zgift-color')===c;});}
  function zgiftAnyAvailable(){return zgiftIds().some(function(id){return zgift.live[id]===true;});}
  function zgiftColourAvailable(c){return zgiftSizeBtnsFor(c).some(function(b){return zgift.live[b.getAttribute('data-zgift-variant')]===true;});}
  function zgiftFirstFree(c){return zgiftSizeBtnsFor(c).filter(function(b){return zgift.live[b.getAttribute('data-zgift-variant')]===true;})[0];}

  /* the customer's own clock can be wrong or set deliberately: trust the
     server's Date header instead, so the gift can't be triggered off-window */
  function zgiftNow(){return Date.now()+zgift.skew;}
  function zgiftSyncClock(){
    return fetch(routeRoot+'cart.js',{cache:'no-store',headers:{Accept:'application/json'}}).then(function(r){
      var d=r.headers.get('Date'),t=d?Date.parse(d):NaN;
      if(!isNaN(t))zgift.skew=t-Date.now();
    }).catch(function(){});
  }
  /* The picker is shown whenever the offer is on the page - Liquid stops
     rendering it after the campaign end. Whether the pair is actually FREE is
     decided by the scheduled Shopify discount, and zgiftVerifyFree() below
     checks the real cart afterwards, so a mismatch can never charge anyone. */
  function zgiftWindowOpen(){return Boolean(zgiftBox)&&!zgift.dead;}
  function zgiftLoadStock(){
    return Promise.all(zgiftHandles.map(function(h){
      return fetch(routeRoot+'products/'+h+'.js',{cache:'no-store',headers:{Accept:'application/json'}})
        .then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});
    })).then(function(list){
      var live={},seen=false;
      list.forEach(function(p){if(p&&p.variants){seen=true;p.variants.forEach(function(v){live[String(v.id)]=!!v.available;});}});
      if(seen)zgift.live=live;
      return zgift.live;
    });
  }
  function zgiftKill(){
    if(zgift.dead)return;
    zgift.dead=true;zgift.variant='';
    document.documentElement.setAttribute('data-zgift-soldout','');
    if(zgiftBox)zgiftBox.hidden=true;
    if(zgiftTimer){clearInterval(zgiftTimer);zgiftTimer=null;}
  }
  function zgiftRender(){
    if(!zgiftBox||zgift.dead)return;
    if(!zgiftAnyAvailable()){zgiftKill();return;}
    zgiftBox.hidden=false;
    /* the chosen colour just sold out: move to one that has not */
    if(!zgiftColourAvailable(zgift.color)){
      var alt=zgiftColourBtns().map(function(b){return b.getAttribute('data-zgift-color');}).filter(zgiftColourAvailable)[0];
      if(alt)zgift.color=alt;
    }
    /* the chosen size just sold out: move to the first one left in this colour */
    if(zgift.live[zgift.variant]!==true){
      var free=zgiftFirstFree(zgift.color);
      zgift.variant=free?free.getAttribute('data-zgift-variant'):'';
    }
    zgiftColourBtns().forEach(function(b){
      var c=b.getAttribute('data-zgift-color'),avail=zgiftColourAvailable(c);
      b.disabled=!avail;
      b.classList.toggle('on',avail&&zgift.color===c);
    });
    zgiftBox.querySelectorAll('[data-zgift-art]').forEach(function(img){
      img.classList.toggle('on',img.getAttribute('data-zgift-art')===zgift.color);
    });
    zgiftSizeBtns().forEach(function(b){
      var id=b.getAttribute('data-zgift-variant'),avail=zgift.live[id]===true;
      b.hidden=b.getAttribute('data-zgift-color')!==zgift.color;
      b.disabled=!avail;
      b.classList.toggle('on',avail&&zgift.variant===id);
    });
    var status=zgiftBox.querySelector('[data-zgift-status]');
    if(status)status.textContent=zgift.variant?'FREE · added to your order':'Pick your pair';
    var note=zgiftBox.querySelector('[data-zgift-note]');
    if(note){
      note.hidden=false;
      note.textContent=zgift.variant
        ?'Your free pair is added to the cart automatically with this bundle.'
        :'Choose a colour and size to get your free pair.';
    }
  }
  function zgiftSelectColour(c){
    if(!zgiftBox)return;
    zgift.color=c;
    var free=zgiftFirstFree(c);
    zgift.variant=free?free.getAttribute('data-zgift-variant'):'';
    zgiftRender();
  }
  function zgiftLine(){
    if(!zgiftBox||zgift.dead||!zgift.variant)return null;
    if(!zgiftWindowOpen())return null;
    if(zgift.live[zgift.variant]!==true)return null;
    return {id:Number(zgift.variant),quantity:1,properties:{_zorro_gift:'first-hour'}};
  }
  /* Never let a "free" pair be charged: if the discount is not running the
     line comes back priced, so it is removed again straight away. */
  function zgiftVerifyFree(){
    return fetch(routeRoot+'cart.js',{cache:'no-store',headers:{Accept:'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){
        var paid=(cart.items||[]).filter(function(i){return i.properties&&i.properties._zorro_gift&&i.line_price>0;});
        if(!paid.length)return true;
        return paid.reduce(function(chain,i){
          return chain.then(function(){
            return fetch(routeRoot+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:i.key,quantity:0})});
          });
        },Promise.resolve()).then(function(){return false;});
      }).catch(function(){return true;});
  }
  /* Shopify adds a multi-item cart request atomically: if the free pair just
     sold out the whole call 422s, which would silently drop the bundle too. */
  function zgiftAdd(items,msg){
    fetch(routeRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){
        if(r.ok)return r.json().then(zgiftVerifyFree).then(function(wasFree){
          showToast(wasFree?msg:'Free pair is not available right now');
          refresh(true);
        });
        return zgiftLoadStock().then(function(){
          zgiftRender();
          return fetch(routeRoot+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[items[0]]})})
            .then(function(r2){return r2.json();})
            .then(function(){showToast(addedLabel);refresh(true);});
        });
      }).catch(function(){});
  }
  /* the gift is only free while the bundle is in the cart (that is what the
     Buy X get Y discount keys off), so never leave an orphan pair behind */
  function zgiftPrune(cart){
    if(zgift.pruning||!zgiftBox||!cart||!cart.items||!cart.items.length)return;
    var bundleId=String(zgiftBox.getAttribute('data-zgift-bundle-product')||'');
    if(!bundleId)return;
    if(cart.items.some(function(i){return String(i.product_id)===bundleId;}))return;
    var orphans=cart.items.filter(function(i){return i.properties&&i.properties._zorro_gift;});
    if(!orphans.length)return;
    zgift.pruning=true;
    var next=function(i){
      if(i>=orphans.length){zgift.pruning=false;refresh(false);return;}
      fetch(routeRoot+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:orphans[i].key,quantity:0})})
        .then(function(){next(i+1);}).catch(function(){zgift.pruning=false;});
    };
    next(0);
  }
  if(zgiftBox){
    zgiftSizeBtns().forEach(function(b){
      zgift.live[b.getAttribute('data-zgift-variant')]=b.getAttribute('data-zgift-avail')==='true';
    });
    zgiftBox.addEventListener('click',function(e){
      var b=e.target.closest?e.target.closest('.zgift-opt'):null;
      if(!b||b.disabled)return;
      if(b.closest('[data-zgift-sizes]')){zgift.variant=b.getAttribute('data-zgift-variant');zgiftRender();return;}
      zgiftSelectColour(b.getAttribute('data-zgift-color'));
    });
    /* warm the colour that is not on screen yet, so switching never flashes
       an empty box while a 300KB PNG downloads */
    var warm=function(){zgiftBox.querySelectorAll('[data-zgift-art]').forEach(function(img){var pre=new Image();pre.src=img.getAttribute('src');});};
    if(window.requestIdleCallback)window.requestIdleCallback(warm,{timeout:3000});else window.setTimeout(warm,1200);
    zgiftSelectColour(zgiftColourAvailable('white')?'white':'black');
    zgiftSyncClock().then(zgiftLoadStock).then(function(){
      zgiftSelectColour(zgiftColourAvailable(zgift.color)?zgift.color:'white');
    }).catch(function(){});
    zgiftTimer=window.setInterval(function(){
      if(zgift.dead)return;
      if(zgiftWindowOpen())zgiftLoadStock().then(zgiftRender);
      else zgiftRender();
    },15000);
  }

  setPrice(state.price,state.was);
  refresh(false);
})();
